import { ReactNode } from "react";

import { CredentialVerificationStatus } from "../generated-graphql/graphql";
import { credentialVerificationStatusToLabel } from "../util/constants";
import { StatusChip, StatusChipColor } from "./StatusChip";

function statusToColor(status: CredentialVerificationStatus): StatusChipColor {
  switch (status) {
    case CredentialVerificationStatus.Good:
      return "success";
    case CredentialVerificationStatus.NotAttempted:
      return "default";
    case CredentialVerificationStatus.CurrentlyVerifying:
      return "info";
    case CredentialVerificationStatus.InUse:
    case CredentialVerificationStatus.ExpiredPassword:
    case CredentialVerificationStatus.Locked:
    case CredentialVerificationStatus.RequiresNewPassword:
    case CredentialVerificationStatus.FailedOneTimePassword:
      return "warning";
    case CredentialVerificationStatus.BadUsername:
    case CredentialVerificationStatus.BadPassword:
    case CredentialVerificationStatus.InvalidAccessidOrPassword:
    case CredentialVerificationStatus.BadSecurityQuestionAnswer:
    case CredentialVerificationStatus.UnknownNonVerifiable:
    case CredentialVerificationStatus.UnknownErrorNeedsHuman:
      return "error";
  }
}

interface CredentialVerificationStatusChipProps {
  status: CredentialVerificationStatus | null | undefined;
  emptyFallback?: ReactNode;
}

export function CredentialVerificationStatusChip({
  status,
  emptyFallback = null,
}: CredentialVerificationStatusChipProps) {
  if (status == null) return <>{emptyFallback}</>;
  const color = statusToColor(status);
  return (
    <StatusChip
      color={color}
      label={credentialVerificationStatusToLabel(status)}
      // StatusChip's soft "default" fill is alpha(white, 0.08) — invisible on the
      // grid's white surface — so give the neutral chip a visible grey fill.
      sx={color === "default" ? { bgcolor: "action.selected" } : undefined}
    />
  );
}
